import * as React from "react";
const SvgFiRrWebcamSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-webcam-slash_svg__a)">
      <path d="m23.707 22.293-4.934-4.934A9.93 9.93 0 0 0 22 10c0-5.514-4.486-10-10-10a9.93 9.93 0 0 0-7.359 3.227L1.707.293A.999.999 0 1 0 .293 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M12 2c4.411 0 8 3.59 8 8a7.94 7.94 0 0 1-2.644 5.942l-2.126-2.126A5 5 0 0 0 17 10c0-2.757-2.243-5-5-5a5.02 5.02 0 0 0-3.816 1.77L6.058 4.644A7.94 7.94 0 0 1 12 2M9.606 8.192A3.01 3.01 0 0 1 12 7c1.654 0 3 1.346 3 3 0 .947-.448 1.831-1.192 2.394zM17.231 23.938a2.3 2.3 0 0 1-.535.062H7.302a2.28 2.28 0 0 1-1.986-1.142 2.28 2.28 0 0 1-.017-2.293 7.1 7.1 0 0 1 1.631-1.949A10 10 0 0 1 2.138 8.334a1 1 0 0 1 1.972.332 8.006 8.006 0 0 0 9.223 9.223 1 1 0 0 1 .332 1.972 10.05 10.05 0 0 1-4.578-.295 5.07 5.07 0 0 0-2.048 1.982.29.29 0 0 0 .003.301.29.29 0 0 0 .258.149h9.394c.537-.125 1.113.201 1.241.738.127.538-.168 1.072-.706 1.2z" />
    </g>
    <defs>
      <clipPath id="fi-rr-webcam-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWebcamSlash;
